<template>
  <base-add></base-add>
</template>

<script>
  import baseAdd from './add';
  export default {
    name: 'materialSalesLadingbillEdit',
    components: {
      baseAdd,
    },
  };
</script>
